/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RefferalProgramRewardCouponBatchApiModel } from './refferal-program-reward-coupon-batch';
import { RewardValueTypeApiModel } from './reward-value-type';
import { RewardGrantPeriodTypeApiModel } from './reward-grant-period-type';
import { PromotionalBonusesExpireTypeApiModel } from './promotional-bonuses-expire-type';
import { PromotionalBonusesStartingTypeApiModel } from './promotional-bonuses-starting-type';
import { RefferalProgramRewardSpecialAccountApiModel } from './refferal-program-reward-special-account';
import { ImageObjectApiModel } from './image-object';
import { RefferalProgramLevelApiModel } from './refferal-program-level';
import { BenefitsChargeTypeBaseApiModel } from './benefits-charge-type-base';

export interface ReferralProgramApiModel {
  /**
   * Referral program active flag
   */
  active?: number | null;
  /**
   * Description (optional)
   */
  description?: string | null;
  /**
   * Referral program public description for referral (optional)
   */
  referral_description?: string | null;
  referral_logo?: ImageObjectApiModel;
  /**
   * Bonuses currency (optional)
   */
  referral_reward_bonuses_currency?: string | null;
  referral_reward_coupon_batch?: RefferalProgramRewardCouponBatchApiModel;
  /**
   * Value of promotional bonuses expire date (optional)
   */
  referral_reward_promotional_bonuses_expire_date?: string | null;
  referral_reward_promotional_bonuses_expire_type?: PromotionalBonusesExpireTypeApiModel;
  /**
   * Value of promotional bonuses expire (optional)
   */
  referral_reward_promotional_bonuses_expire_value?: number | null;
  /**
   * Value of promotional bonuses start date (optional)
   */
  referral_reward_promotional_bonuses_starting_date?: string | null;
  referral_reward_promotional_bonuses_starting_type?: PromotionalBonusesStartingTypeApiModel;
  /**
   * Value of promotional bonuses start (optional)
   */
  referral_reward_promotional_bonuses_starting_value?: number | null;
  referral_reward_special_account?: RefferalProgramRewardSpecialAccountApiModel;
  /**
   * Referral reward type (optional)
   */
  referral_reward_type?: ReferralProgramApiModelReferralRewardTypeEnum | null;
  /**
   * Referral reward value (optional)
   */
  referral_reward_value?: number | null;
  /**
   * Referral program public title for referral (optional)
   */
  referral_title?: string | null;
  /**
   * Referral program public description for referrer (optional)
   */
  referrer_description?: string | null;
  referrer_logo?: ImageObjectApiModel;
  /**
   * Value of the number of checks that will be rewarded (optional)
   */
  referrer_reward_grant_checks_number?: number | null;
  referrer_reward_grant_period_type?: RewardGrantPeriodTypeApiModel;
  /**
   * Value of time period that will be rewarder (optional)
   */
  referrer_reward_grant_period_value?: number | null;
  /**
   * Referral reward grant type (optional)
   */
  referrer_reward_grant_type?: ReferralProgramApiModelReferrerRewardGrantTypeEnum | null;
  /**
   * Levels of referral program (optional)
   */
  referrer_reward_levels?: Array<RefferalProgramLevelApiModel> | null;
  /**
   * Value of promotional bonuses expire date (optional)
   */
  referrer_reward_promotional_bonuses_expire_date?: string | null;
  referrer_reward_promotional_bonuses_expire_type?: PromotionalBonusesExpireTypeApiModel;
  /**
   * Value of promotional bonuses expire (optional)
   */
  referrer_reward_promotional_bonuses_expire_value?: number | null;
  /**
   * Value of promotional bonuses start date (optional)
   */
  referrer_reward_promotional_bonuses_starting_date?: string | null;
  referrer_reward_promotional_bonuses_starting_type?: PromotionalBonusesStartingTypeApiModel;
  /**
   * Value of promotional bonuses start (optional)
   */
  referrer_reward_promotional_bonuses_starting_value?: number | null;
  referrer_reward_special_account?: RefferalProgramRewardSpecialAccountApiModel;
  referrer_reward_type?: BenefitsChargeTypeBaseApiModel;
  /**
   * Referrer reward value (optional)
   */
  referrer_reward_value?: number | null;
  referrer_reward_value_type?: RewardValueTypeApiModel;
  /**
   * Referral program public title for referrer (optional)
   */
  referrer_title?: string | null;
  /**
   * Title (optional)
   */
  title?: string | null;
}
export enum ReferralProgramApiModelReferralRewardTypeEnum {
  None = 'none',
  RegularBonuses = 'regular-bonuses',
  PromotionalBonuses = 'promotional-bonuses',
  SpecialAccount = 'special-account',
  Coupon = 'coupon'
}
export enum ReferralProgramApiModelReferrerRewardGrantTypeEnum {
  None = 'none',
  ForEveryCheck = 'for-every-check',
  ForValuedFirstChecks = 'for-valued-first-checks',
  ForValuedPeriodTime = 'for-valued-period-time'
}
